import { useTheme } from "@mui/material";
import { useRef } from "react";
import CustomButton from "../../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../../media/images/icons/arrow-left-circle";

interface Props {
  title: string;
  filePath: string;
  index: number;
  handleUploadFile: (file: File, index: number) => void;
}

export default function UploadButton({
  title,
  filePath,
  index,
  handleUploadFile,
}: Props) {
  const theme = useTheme();

  const myRef = useRef<HTMLInputElement>(null);
  return !filePath.length ? (
    <>
      <CustomButton
        onClick={() => myRef.current?.click()}
        flexDirection="row"
        title={title}
        justifyContent="center"
        bgColor="bgColor.white"
        borderColor={theme.palette.secondary.main}
        rippleColor={theme.palette.secondary.main}
        width="100%"
        textColor={theme.palette.secondary.main}
        fSize="16px"
        px="10px"
        py="10px"
        borderRadius="10px"
        icon2={<ArrowLeftCircle size={32} />}
      />
      <input
        ref={myRef}
        onChange={(e) => {
          if (e.target.files?.length) {
            const myFile = e.target.files[0];

            handleUploadFile(e.target.files[0], index);

            console.log(myFile);
          }
        }}
        hidden
        type="file"
      />
    </>
  ) : (
    <></>
  );
}
